import Content from "uxp-documentation/src/pages/uxp-api/reference-css//Pseudo-classes/index.md";
import * as React from 'react';
export default {
  Content,
  React
};